<template>
  <b-jumbotron>
    <div class="text-white">
      <div class="mb-5">
        <b-link v-b-modal.sidebar-chapter class="browse">
          <b-icon icon="list" class="h2 mb-0"></b-icon><span>Categories</span>
        </b-link>
      </div>
      <b-container>
        <slot name="heading"></slot>
        <b-row align-h="center">
          <b-col :cols="12" :lg="8">
            <div class="search-form">
              <b-form @submit.prevent @keyup.enter="doFullPageSearch">
                <b-input-group size="lg">
                  <p class="h5">
                    <b-icon
                      icon="search"
                      variant="secondary"
                      class="icon"
                    ></b-icon>
                  </p>
                  <b-form-input
                    type="text"
                    v-model="searchQuery"
                    placeholder="Enter HS Code or product description"
                    class="d-none d-sm-block"
                  />
                  <b-form-input
                    type="text"
                    v-model="searchQuery"
                    placeholder="Enter HS Code"
                    class="d-block d-sm-none"
                  />
                  <b-btn
                    :disabled="loading"
                    class="search-btn"
                    variant="primary"
                    size="sm"
                    @click="doFullPageSearch"
                  >
                    <b-spinner
                      class="mr-1"
                      small
                      label="loading"
                      v-if="loading"
                    ></b-spinner
                    >Search
                  </b-btn>
                </b-input-group>
              </b-form>
              <ul class="list-group">
                <li class="spinner" v-if="loading">
                  <b-spinner variant="primary" label="loading"></b-spinner>
                </li>
                <li v-for="(result, key, i) in searchResult" :key="i">
                  <b-link
                    class="list-group-item text-truncate"
                    :to="{ name: 'hsCode', params: { id: key } }"
                    @click="handleClick"
                  >
                    <b-icon icon="search" class="small-search-icon"></b-icon>
                    <span class="code-pill">{{ key }}</span>
                    {{ result.desc }}
                  </b-link>
                </li>
                <li
                  class="list-group-item text-center more-results"
                  v-if="fetched && Object.keys(searchResult).length > 0"
                >
                  <b-link
                    class="text-uppercase"
                    :to="{
                      name: 'searchResults',
                      params: { searchQuery: this.searchQuery }
                    }"
                    >Click for more results</b-link
                  >
                </li>
                <li
                  class="list-group-item text-center more-results"
                  v-if="fetched && Object.keys(searchResult).length === 0"
                >
                  No Results Found
                </li>
              </ul>
            </div>
          </b-col>
        </b-row>
        <b-row align-h="center">
          <b-col :cols="12" :lg="10">
            <div
              class="keywords mt-3 d-flex justify-content-center align-items-center"
            >
              <div class="mr-3">Frequently Searched:</div>
              <div class="keyword-list">
                <ul class="keyword-search">
                  <li v-for="keyword in keywords" :key="keyword">
                    <b-link
                      class="keyword-item mr-3"
                      :to="{
                        name: 'searchResults',
                        params: { searchQuery: keyword }
                      }"
                      >{{ keyword }}</b-link
                    >
                  </li>
                </ul>
              </div>
            </div>
          </b-col>
        </b-row>
        <b-row align-h="center">
          <b-col :cols="12" :lg="10">
            <div
              class="keywords mt-3 d-flex justify-content-center align-items-center"
              v-if="!fetched"
            >
              <span>
                <b-link v-b-modal.sidebar-chapter>
                  See all categories
                  <b-icon icon="caret-right-fill"></b-icon>
                </b-link>
              </span>
            </div>
          </b-col>
        </b-row>
      </b-container>
    </div>
  </b-jumbotron>
</template>

<script>
import _ from 'lodash'
import { hsnQueryMixin } from '@/mixins/query'

export default {
  data() {
    return {
      searchQuery: '',
      isTyping: false,
      searchResult: [],
      loading: false,
      count: 4,
      fetched: null,
      page: 1,
      keywords: ['Cement', 'Battery', 'Furniture', 'Rice', 'Sugar']
    }
  },
  watch: {
    searchQuery: _.debounce(async function () {
      if (this.searchQuery.length > 2) {
        await this.hsnQuery()
      } else if (this.searchQuery.length === 0) {
        this.searchResult = []
        this.fetched = false
      }
    }, 400)
  },
  methods: {
    doFullPageSearch() {
      if (this.searchQuery.length > 2) {
        this.$router.push({
          name: 'searchResults',
          params: { searchQuery: this.searchQuery }
        })
      }
    },
    handleClick() {
      this.searchQuery = ''
    }
  },
  mixins: [hsnQueryMixin]
}
</script>

<style lang="scss" scoped>
.browse {
  font-family: $font-family-sans-serif;
  color: $dark-blue;
  text-transform: uppercase;
  letter-spacing: 2px;
  text-decoration: none;

  span {
    position: relative;
    top: 1px;
  }
}

.list-group {
  list-style-type: none;
}

.list-group-item {
  color: $product-light-grey;
  border: none;
}

.search-form {
  position: relative;
  box-shadow: 0 2px 5px 0 rgb(0 0 0 / 5%);
  border: solid 1px $product-shadow;
  border-radius: 5px;
  background-color: $white;

  .list-group {
    border-top: 1px solid $gray-300;

    .list-group-item {
      .small-search-icon {
        position: absolute;
        left: 0.75rem;
        top: 1.5rem;
      }

      &.more-results {
        background-color: $gray-100;
      }

      .code-pill {
        padding: 0.2rem 1rem;
        font-size: 1.25rem;
        font-family: $font-family-sans-serif;
        font-weight: bold;
        border-radius: 2px;
        background: $light-blue;
        display: inline-block;
        margin: 0 0.6rem 0 1.25rem;
      }
    }

    .spinner {
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 3rem;
    }
  }

  .form-control {
    padding-left: 2.5rem;
    height: 4.375rem;
    font-size: 1rem;
    border-radius: 5px;
    border: 0;
    box-shadow: none;
  }
}

.keywords {
  color: $product-light-grey;

  .keyword-list {
    display: inline-flex;

    .keyword-search {
      list-style: none;
      display: contents;

      .keyword-item {
        color: $secondary;
      }
    }
  }
}

.icon {
  position: absolute;
  z-index: 4;
  top: 1.7rem;
  left: 0.625rem;
}

.search-btn {
  position: absolute;
  z-index: 4;
  top: 1rem;
  right: 1rem;
  border-radius: 0.3em;
}

.search-icon {
  margin-right: 0.625rem;
}

.align-icon {
  display: contents;
}
</style>
